module.exports = __webpack_public_path__ + "img/12.6331f1f4.png";